
import {Container,Box,Typography,Button} from "@mui/material"
import { Logo } from "../allComponents/AllComponents";
import RouterLink from "../routerLink/RouterLink";


const PageNotFound = () => {
  
    return (
      <>
  
        <Container>
          <Box
            sx={{
              py: 12,
              maxWidth: 480,
              mx: 'auto',
              display: 'flex',
              minHeight: '100vh',
              textAlign: 'center',
              alignItems: 'center',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
          >
            <Typography variant="h3" sx={{ mb: 3 }}>
              Sorry, page not found!
            </Typography>
  
            <Typography sx={{ color: 'text.secondary' }}>
              Sorry, we couldn’t find the page you’re looking for. Perhaps you’ve mistyped the URL? Be
              sure to check your spelling.
            </Typography>
  
  
            <Button sx={{mt:10}} href="/" size="large" variant="contained" component={RouterLink}>
              Go to Home
            </Button>
          </Box>
        </Container>
      </>
    );
  }
  

  export default PageNotFound;